import { useState } from "react";
import client from "../clients";
import libphonenumber from 'google-libphonenumber';
const phoneUtil = libphonenumber.PhoneNumberUtil.getInstance();


export const validateEmail = (email) => {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
};

export const validatePhoneNumber=(phoneNumber,countryCode='IN')=>{
   try{
    const parsedNumber = phoneUtil.parse(`${phoneNumber}`, countryCode);
    const isValid = phoneUtil.isValidNumber(parsedNumber);
    return isValid;
   }catch(error){
    return false;
   }
}

export const objectToQueryString = (obj) => {
  var str = [];
  for (var p in obj)
    if (obj.hasOwnProperty(p)) {
      str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
    }
  return str.join("&");
}

export const useAsyncState = initialState => {
  const [state, setState] = useState(initialState);

  const asyncSetState = value => {
    return new Promise(resolve => {
      setState(value);
      setState((current) => {
        resolve(current);
        return current;
      });
    });
  };

  return [state, asyncSetState];
};

export const startLoader = () => {
  let element = document.getElementById("app-loader");
  if (element) {
    element.style.display = "block";
  }
}



export const stopLoader = () => {
  let element = document.getElementById("app-loader");
  if (element) {
    element.style.display = "none";
  }
}

export const getUserRole = role => {
  let keyNames = ['Workout Plus Admin', 'Gym Owner', 'Gym Admin', 'Gym Programmer', 'Gym Instructor', 'Branch Admin', 'Branch Programmer', 'Branch Instructor', 'Member',"Brand User","Nutritionist","Manage Ads User"];
  //let keyNames = ['Workout Plus Admin', 'Gym Owner', 'Gym Admin', 'Branch Admin', 'Branch Instructor', 'Member'];
  return keyNames[role];
}

export const isTrainer = (user) => !!user && (user.role === 2 || user.role === 5);


export const getUserRoleList = role => {
  var keyNames = [0, 1, 2, 3, 4, 5, 6, 7, 8,11];
  if (role === 1) {
    keyNames = keyNames.splice(1, 1);
  }
  if (role === 2) {
    keyNames = keyNames.splice(2, keyNames.length);
  }
  if (role === 5) {
    keyNames = keyNames.splice(0, 5)
  }
  return keyNames;
}


// export function lazy_load_css(path) {
//   //The function responsible for lazy loading our css files
//   let type_of_path = typeof path; //This refers to the type of the path. It can be string or object 
//   switch (type_of_path) {
//     case "object":
//       var head = document.getElementsByTagName("head")[0]; //Get's the head element 
//       for (let i = 0; i < path.length; i++) {
//         //Loops through all the paths
//         var link = document.createElement("link"); //Creates a link element 
//         link.href = path[i]; //Assigns a path to the tag 
//         link.rel = "stylesheet"; //Set it's rel to stylesheet 
//         link.type = "text/css"; //Set's it's type to text/css
//         head.appendChild(link); //Appends it to the head of the document.
//       }
//       break;
//     case "string": //If the path is a single path
//       var head = document.getElementsByTagName("head")[0]; //Get the head element from the html document
//       var link = document.createElement("link"); //Create the link element
//       link.href = path; //Assign the value of path to the link's href 
//       link.rel = "stylesheet"; //Assign 'stylesheet' to the link 
//       link.type = "text/css";
//       head.appendChild(link); //Appends the link to the head of the document. 
//       break;
//   }
// }

export function lazy_load_css(href) {
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = href;
  document.head.appendChild(link);
};


export function formatDateTime(date, isTimeRequired, isUtc){
  const options = {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    timeZone: 'Asia/Kolkata'
  };

  if (isUtc) options.timeZone = 'UTC';

  let formattedDate = '';
  if (isTimeRequired) {
    options.hour = 'numeric';
    options.minute = 'numeric';
    // options.second = 'numeric';
  }
  if (date) {
    formattedDate = new Intl.DateTimeFormat('en-IN', options).format(new Date(date));
  }
  return formattedDate;
}

export function formatDateTimeToText(dateString){
  let monthName=client.config.monthNames[parseInt(dateString.split('/')[1])-1];
  return `${dateString.split('/')[0]} ${monthName} ${dateString.split('/')[2]}`;
}

export function getShortString(value,length=0){
  if(!value) return "";
  if(length===0) length=value.length;
  return `${value.length>length?value.substring(0,length)+"...":value}`;
}

export function calculateBMIFromKgInchValue(weightKg, heightFeet) {
  // Convert height from inches to meters
  let heightInches = heightFeet * 12;
  let heightMeters = heightInches * 0.0254;
  
  // Calculate BMI
  let bmi = weightKg / (heightMeters * heightMeters);
  
  // Determine BMI status
  let status;
  if (bmi < 18.5) {
      status = "Underweight";
  } else if (bmi >= 18.5 && bmi < 24.9) {
      status = "Normal weight";
  } else if (bmi >= 25 && bmi < 29.9) {
      status = "Overweight";
  } else if (bmi >= 30 && bmi < 34.9) {
      status = "Obesity (Class 1)";
  } else if (bmi >= 35 && bmi < 39.9) {
      status = "Obesity (Class 2)";
  } else {
      status = "Severe Obesity (Class 3)";
  }
  
  // Return BMI and status
  return { bmi:bmi.toFixed(2), status};
}


export function calculateBMIKgFeet(weight, heightFeet) {
  // Convert weight from pounds to kilograms (1 lb = 0.453592 kg)
  let weightKg = weight;
  
  // Convert height from feet to inches and then to meters (1 ft = 12 inches, 1 inch = 0.0254 meters)
  let heightInches = heightFeet * 12;
  let heightMeters = heightInches * 0.0254;
  
  // Calculate BMI
  let bmi = weightKg / (heightMeters * heightMeters);
  
  // Determine BMI status
  let status;
  if (bmi < 18.5) {
      status = "Underweight";
  } else if (bmi >= 18.5 && bmi < 24.9) {
      status = "Normal weight";
  } else if (bmi >= 25 && bmi < 29.9) {
      status = "Overweight";
  } else if (bmi >= 30 && bmi < 34.9) {
      status = "Obesity (Class 1)";
  } else if (bmi >= 35 && bmi < 39.9) {
      status = "Obesity (Class 2)";
  } else {
      status = "Severe Obesity (Class 3)";
  }
  
  // Return BMI and status
  return { bmi:bmi.toFixed(2), status};
}

export function getIsDeviceActiveStatus(date){
  var startDate = new Date();
  // Do your operations
  var endDate   = new Date(date);
  var seconds = (endDate.getTime() - startDate.getTime()) / 1000;

  return (seconds < 61)
}

export function formatDate(date) {
  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  const day = date.getDate();
  const month = months[date.getMonth()];
  const year = date.getFullYear();

  return `${day} ${month} ${year}`;
}

export function formatDateDDMMYYYY(date) {
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  return `${day}/${month}/${year}`;
}

// export function formatDateAndTime(date) {
//   const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", 
//                   "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
//   const day = date.getDate();
//   const month = months[date.getMonth()];
//   const year = date.getFullYear();

//   let hours = date.getHours();
//   const minutes = date.getMinutes().toString().padStart(2, '0');
//   const ampm = hours >= 12 ? 'PM' : 'AM';

//   hours = hours % 12;
//   hours = hours ? hours : 12; // the hour '0' should be '12'

//   return `${day} ${month} ${year}, ${hours}:${minutes} ${ampm}`;
// }

export function formatDateAndTime(dateInput) {
  const date = new Date(dateInput);

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  let hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, "0");

  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12;

  const formattedHours = String(hours).padStart(2, "0");

  return `${day}/${month}/${year}  at  ${formattedHours}:${minutes} ${ampm}`;
}

export function formatNumberCompact(num) {
  if (num < 1000) {
    return num.toString();
  }
  const units = ['K', 'M', 'B', 'T'];
  let unitIndex = -1;
  let value = num;

  while (value >= 1000 && unitIndex < units.length - 1) {
    value /= 1000;
    unitIndex++;
  }

  return `${value.toFixed(2)} ${units[unitIndex]}`;
}

export function convert_24_to_12 (time24) {
  const [hours, minutes] = time24.split(':').map(Number);
  const period = hours >= 12 ? 'PM' : 'AM';
  const hours12 = hours % 12 || 12; // Convert 0 to 12 for midnight
  return `${hours12}:${minutes.toString().padStart(2, '0')} ${period}`;
}

export function getMealTime(hour) {
  if (hour >= 5 && hour < 10) {
      return "Breakfast";
  } else if (hour >= 10 && hour < 12) {
      return "Morning Snack";
  } else if (hour >= 12 && hour < 15) {
      return "Lunch";
  } else if (hour >= 15 && hour < 17) {
      return "Afternoon Snack";
  } else if (hour >= 17 && hour < 21) {
      return "Dinner";
  } else if (hour >= 21 && hour < 24) {
      return "Evening Snack";
  } else {
      return "Late-Night Snack";
  }
}

export function convertSeconds(totalSeconds) {
  const secondsInMinute = 60;
  const secondsInHour = 60 * secondsInMinute;
  const secondsInDay = 24 * secondsInHour;
  const secondsInYear = 365 * secondsInDay; // Approximate (non-leap year)

  const years = Math.floor(totalSeconds / secondsInYear);
  totalSeconds %= secondsInYear;

  const days = Math.floor(totalSeconds / secondsInDay);
  totalSeconds %= secondsInDay;

  const hours = Math.floor(totalSeconds / secondsInHour);
  totalSeconds %= secondsInHour;

  const minutes = Math.floor(totalSeconds / secondsInMinute);
  const seconds = totalSeconds % secondsInMinute;

  let res = seconds + "s";

  if(minutes>0) res = `${minutes}m : `+res;
  if(hours>0) res = `${hours}h : `+res;
  if(days>0) res = `${days}d : `+res;
  if(years>0) res = `${years}y : `+res;


  return res;
}

export function getTimeInAmPm(dateInput,isUtc) {
  // If it's a string without timezone, force local parsing
  const date = typeof dateInput === 'string'
    ?isUtc?  new Date(dateInput) : new Date(dateInput.replace('T', ' '))  // treats as local time
    : dateInput;

  let hours = isUtc? date.getUTCHours() : date.getHours();
  const minutes = isUtc? date.getUTCMinutes() : date.getMinutes();
  const ampm = hours >= 12 ? 'PM' : 'AM';

  hours = hours % 12 || 12;
  const minutesStr = minutes < 10 ? '0' + minutes : minutes;


  return hours + ':' + minutesStr + ' ' + ampm;
}

export function convertTo24Hour(time) {
  let [hours, minutes, period] = time.match(/(\d{2}):(\d{2})\s(AM|PM)/).slice(1);
  hours = period === "PM" && hours !== "12" ? String(+hours + 12) 
         : period === "AM" && hours === "12" ? "00" 
         : hours;
  return `${hours}:${minutes}`;
}

export function doTimeRangesOverlap(start1, end1, start2, end2) {
  // Convert time to minutes for easy comparison
  function timeToMinutes(time) {
      return time.hr * 60 + time.min;
  }
  
  let start1Min = timeToMinutes(start1);
  let end1Min = timeToMinutes(end1);
  let start2Min = timeToMinutes(start2);
  let end2Min = timeToMinutes(end2);
  
  // Check if the two time ranges overlap
  return (start1Min < end2Min && start2Min < end1Min);
}

export function findAvailableSlots(start, end, duration) {
  function timeToMinutes(time) {
    return parseInt(time.hr) * 60 + parseInt(time.min);
  }

  function minutesToTime(minutes) {
    let hr = Math.floor(minutes / 60);
    let min = minutes % 60;
    let period = hr >= 12 ? "PM" : "AM";
    hr = hr % 12 || 12; // Convert 0 to 12 for AM/PM format
    return {
      hr: `${hr}`.padStart(2, "0"),
      min: `${min}`.padStart(2, "0"),
      period,
    };
  }

  const startMin = timeToMinutes(start);
  const endMin = timeToMinutes(end);
  const gap = 5; // 5-minute gap between slots
  let slots = [];

  for (let t = startMin; t + duration <= endMin; t += duration + gap) {
    const slotStart = minutesToTime(t);
    const slotEnd = minutesToTime(t + duration);
    slots.push({ start: slotStart, end: slotEnd });
  }

  return slots;
}


export function checkVideoPlatform(url) {
  if (typeof url !== 'string') return {error:"Invalid URL"};
  
  if (/^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.be)/i.test(url)) {
      return {platform:"YouTube"}
  } else if (/^(https?:\/\/)?(www\.)?vimeo\.com/i.test(url)) {
      return {platform:"Vimeo"};
  } else {
      return {error:"Unknown Platform"};
  }
}


export function getAllDateTimeSlots(startDate, endDate, timeSlotMap) {

  function convertTo24Hour(hr, min, period) {
    hr=parseInt(hr);
    min=parseInt(min);
    if (period.toUpperCase() === 'PM' && hr !== 12) hr += 12;
    if (period.toUpperCase() === 'AM' && hr === 12) hr = 0;
    return { hours: hr, minutes: min };
  }

  const start = new Date(startDate);
  const end = new Date(endDate);
  const result = [];

  while (start <= end) {
    const [year, month, day] = [
      start.getFullYear(),
      start.getMonth(),
      start.getDate()
    ];

    const fullDayName = start.toLocaleDateString("en-US", { weekday: "long" });
    const dayName = fullDayName.toLowerCase().substring(0,3); // e.g. Sunday, Monday
    const slots = timeSlotMap[dayName] || [];

    slots.forEach(slot => {
      const s = convertTo24Hour(slot.startTime.hr, slot.startTime.min, slot.startTime.period);
      const e = convertTo24Hour(slot.endTime.hr, slot.endTime.min, slot.endTime.period);

      const startTime = new Date(year, month, day, s.hours, s.minutes);
      const endTime = new Date(year, month, day, e.hours, e.minutes);

      const slotStartTime = slot.startTime;
      const slotEndTime = slot.endTime;

      console.log(`${day}-${month}-${year}-/-${s.hours}-${s.minutes}`);
      console.log(new Date(startTime))

      result.push({ start: startTime, end: endTime,slotRange:slot.slotRange,dayName:fullDayName,slotStartTime,slotEndTime,formatDateString:formatDateTime(new Date(startTime)),slot_limit:slot.slot_limit === null? 1 : slot.slot_limit, slot_duration:slot.slot_duration });
    });

    // if(slots.length){
    //   console.log(start);
    // }

    start.setDate(start.getDate() + 1);
  }

  return result;
}

export function isCurrentTimeGreaterThan(inputTimeStr) {
  const now = new Date();

  // Parse input time (e.g., "12:30 AM")
  const [timePart, modifier] = inputTimeStr.split(' ');
  let [hours, minutes] = timePart.split(':').map(Number);

  if (modifier.toUpperCase() === 'PM' && hours !== 12) {
    hours += 12;
  } else if (modifier.toUpperCase() === 'AM' && hours === 12) {
    hours = 0;
  }

  const inputTotalMinutes = hours * 60 + minutes;
  const currentTotalMinutes = now.getHours() * 60 + now.getMinutes();

  return currentTotalMinutes > inputTotalMinutes;
}

export function getStartEndDate(dateStr, startTime, endTime) {
  function convertTo24Hour(hour, min, period) {
    if (period.toUpperCase() === 'PM' && hour !== 12) hour += 12;
    if (period.toUpperCase() === 'AM' && hour === 12) hour = 0;
    return { hour, min };
  }

  const [day, month, year] = dateStr.split('/').map(Number);

  const start = convertTo24Hour(startTime.hr, startTime.min, startTime.period);
  const end = convertTo24Hour(endTime.hr, endTime.min, endTime.period);

  const startDate = new Date(year, month - 1, day, start.hour, start.min);
  const endDate = new Date(year, month - 1, day, end.hour, end.min);

  return { startDate, endDate };
}

export function isStartDateVerified(start_date,input_date,check_time) {
  const inputDate = new Date(input_date);
  const startDate = new Date(start_date);

  if(!check_time){
    inputDate.setHours(0, 0, 0, 0);
    startDate.setHours(0, 0, 0, 0);
  }

  return inputDate >= startDate;
}


export function addQueryParam(key,value){
  const url = new URL(window.location);
  url.searchParams.set(key, value);
  window.history.replaceState({});
}

export function removeQueryParam(key){
  const url = new URL(window.location);
  url.searchParams.delete(key);
  window.history.replaceState();
}

export function clearAllQueryParam (){
  const url = new URL(window.location);
  url.search = "";
  window.history.replaceState();
}

export function numberToWords(value) {
  const ones = [
    "", "one", "two", "three", "four", "five", "six",
    "seven", "eight", "nine", "ten", "eleven", "twelve",
    "thirteen", "fourteen", "fifteen", "sixteen",
    "seventeen", "eighteen", "nineteen",
  ];

  const tens = [
    "", "", "twenty", "thirty", "forty", "fifty",
    "sixty", "seventy", "eighty", "ninety",
  ];

  const below100 = (n) =>
    n < 20 ? ones[n] : tens[Math.floor(n / 10)] + (n % 10 ? " " + ones[n % 10] : "");

  const belowThousand = (n) => {
    const parts = [];
    if (n >= 100) {
      parts.push(ones[Math.floor(n / 100)] + " hundred");
      n %= 100;
    }
    if (n > 0) parts.push(below100(n));
    return parts.join(" ");
  };

  // Indian numbering: crore, lakh, thousand
  const intToWords = (n) => {
    if (n === 0) return "zero";
    const parts = [];

    const crore = Math.floor(n / 10000000);
    n %= 10000000;
    const lakh = Math.floor(n / 100000);
    n %= 100000;
    const thousand = Math.floor(n / 1000);
    n %= 1000;

    if (crore) parts.push(intToWords(crore) + " crore");
    if (lakh) parts.push(below100(lakh) + " lakh");
    if (thousand) parts.push(below100(thousand) + " thousand");
    if (n) parts.push(belowThousand(n));

    return parts.join(" ");
  };

  const amount = Math.abs(Number(value)) || 0;
  const totalPaise = Math.round(amount * 100); // avoids float issues like 362.2500001
  const rupees = Math.floor(totalPaise / 100);
  const paise = totalPaise % 100;

  if (rupees === 0 && paise === 0) return "zero only";

  let result = rupees > 0 ? intToWords(rupees) : "";
  if (paise > 0) {
    result += (rupees > 0 ? " & " : "") + below100(paise) + " paise";
  }

  return result + " only";
}

export function get12HourTime(s){ const d=new Date(s); let h=d.getUTCHours(); const m=d.getUTCMinutes().toString().padStart(2,"0"); return `${h%12||12}:${m} ${h>=12?"PM":"AM"}`; };



//localstorage

export function addQueryLocalStorage(key, value) {
  const existing = JSON.parse(localStorage.getItem("queries") || "{}");

  existing[key] = value;

  localStorage.setItem("queries", JSON.stringify(existing));

  // notify same-tab listeners
  window.dispatchEvent(new Event("localStorageChange"));
}

export function removeQueryLocalStorage(key) {
  const existing = JSON.parse(localStorage.getItem("queries") || "{}");

  delete existing[key];

  localStorage.setItem("queries", JSON.stringify(existing));

  window.dispatchEvent(new Event("localStorageChange"));
}


export function getAllQueryLocalStorage() {
  return JSON.parse(localStorage.getItem("queries") || "{}");
}

export function clearAllQueryLocalStorage() {
  localStorage.removeItem("queries");

  // notify listeners (same tab)
  window.dispatchEvent(new Event("localStorageChange"));
}

export function removeGivenQueryLocalStorage(obj) {
  const existing = JSON.parse(localStorage.getItem("queries") || "{}");

  Object.keys(obj).forEach((key) => {
    delete existing[key];
  });

  localStorage.setItem("queries", JSON.stringify(existing));

  // notify listeners
  window.dispatchEvent(new Event("localStorageChange"));
}


export function isValidIP(ip) {
  const regex =
    /^(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)\.(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)\.(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)\.(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)$/;
  return regex.test(ip);
}


export function changeRole(newRole, profile, branchId = null, gymId = null,roleName = null){
  if (typeof window === "undefined") return;

  const storedData = localStorage.getItem("jwt");
  if (!storedData) return;

  const parsedData = JSON.parse(storedData);
  parsedData.user.role = newRole;
  
  if (newRole === 0) {
    parsedData.user.branchId = null;
    parsedData.user.gymId = null;
  } else {
    localStorage.setItem("branchId",branchId);
    localStorage.setItem("gymId",gymId);
    parsedData.user.branchId = branchId;
    parsedData.user.gymId = gymId;
  }

  parsedData.user.roleName = roleName;
  parsedData.user.profile = profile;

  // Save back to localStorage
  localStorage.setItem("jwt", JSON.stringify(parsedData));
};


export function getTotalDays(startDate, endDate) {
    const start = new Date(startDate);
    const end = new Date(endDate);

    const diffTime = end - start; // difference in milliseconds
    const diffDays = diffTime / (1000 * 60 * 60 * 24);

    return diffDays;
}

  export function getTotalPayment(payment){
    let value = 0;


    if(payment){
      if(payment?.amount?.$numberDecimal) value = value + parseFloat(payment.amount.$numberDecimal);
      payment.balance_payments.forEach(balance=>{
        if(balance?.amount?.$numberDecimal) value = value + parseFloat(balance.amount.$numberDecimal);
      })
    }

    return value;
  }


export function getIndianPhoneNumber(phone) {
  if (!phone) return "";

  // Remove spaces, dashes, brackets etc.
  phone = String(phone).replace(/\D/g, "");

  // Remove country code if present
  if (phone.startsWith("91") && phone.length > 10) {
    phone = phone.slice(2);
  }

  // Keep only last 10 digits
  return phone.slice(-10);
}